module.exports = __webpack_public_path__ + "img/Artboard 52 copy.dc2ad34b.png";